import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import SobreMi from "./components/SobreMi";
import Servicios from "./components/Servicios";
import Testimonios from "./components/Testimonios";
import Blog from "./components/Blog";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navbar />
      <main>
        <Hero />
        <SobreMi />
        <Servicios />
        <Testimonios />
        <Blog />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}
